import { render, staticRenderFns } from "./schoolyears.vue?vue&type=template&id=5d2cdcfa&"
import script from "./schoolyears.vue?vue&type=script&lang=js&"
export * from "./schoolyears.vue?vue&type=script&lang=js&"
import style0 from "./schoolyears.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports